
























import {Component, Vue, Watch} from 'vue-property-decorator';
import Loader from "@/components/Loader.vue";
import ApiClient from "@/ApiClient";
import {Response} from "request";
import PersonResponse from "@/model/PersonResponse";
import PersonResponseStatistics from "@/model/PersonResponseStatistics";
//@ts-ignore
import InfiniteSlideBar from 'vue-infinite-slide-bar'
import EnhancedPersonResponse from "@/model/EnhancedPersonResponse";
import IdCard from "@/components/IdCard.vue";

@Component({
    components: {Loader, InfiniteSlideBar, IdCard}
})
export default class RandomTop5TagMembers extends Vue {
    loading = false;
    error = null;
    skillName: string | null = null;
    people: EnhancedPersonResponse[] | null = null;

    mounted() {
        this.loadData(this.$route.params.id)
    }

    @Watch('$route.params.id')
    onRouteChanged(val: string) {
        this.$log.debug("route changed");
        this.loadData(val);
    }

    private randomKey(obj: Object): string {
        const keys = Object.keys(obj);
        //@ts-ignore
        return keys[keys.length * Math.random() << 0];
    }

    private loadData(tag: string) {
        this.$log.debug("Loading data for tag ", tag);
        this.error = null;
        this.loading = true;

        this.skillName = null;
        this.people = null;

        const skills: any = [];
        ApiClient.loadPeopleFromCommunity(tag, (error: any, response: Response, body: any) => {
            this.loading = false;
            if (error) {
                this.$log.error("Can't retrieve data");
                this.$log.error(error);
                this.error = error;
                this.loading = false;
            } else {
                let data: PersonResponse[] = JSON.parse(body).list;
                let stats: PersonResponseStatistics = ApiClient.extractStatisticsFromPersonResponse(data, 99, tag);


                this.$log.debug("top five members: ", stats.tags.top5members);

                this.skillName = this.randomKey(stats.tags.top5members);
                this.people = stats.tags.top5members[this.skillName];

                this.$log.debug('random gives  : ', this.skillName);
                this.$log.debug("members of random : ", this.people);
            }
        });
    }
}
